export default "__VITE_ASSET__4c803f0b__"